module.exports = __webpack_public_path__ + "static/img/0546_4.be730bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_4.jpg
// module id = nXdw
// module chunks = 1